import { FETCH_FOLLOWING_SUCCESS } from '../../actions/fetch-following';

export default function followingMetadataReducer(state = {}, action) {
  switch (action.type) {
    case FETCH_FOLLOWING_SUCCESS:
      return action.meta;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/following/metadata.js